// extracted by mini-css-extract-plugin
export default {"item":"styles_item__-R7DR","title":"styles_title__wJfBY","active":"styles_active__N447Y","description":"styles_description__h8WKq","btn":"styles_btn__KeNbJ"};